import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { cn } from '../../../utils';
import { FormErrorMessage } from '../error-message';
export const FormTextarea = ({ name, ...props }) => {
    const context = useFormContext();
    const error = context.formState.errors[name]?.message?.toString();
    return (_jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("textarea", { ...context.register(name), ...props, id: name, className: cn('rounded-xl border border-gray-100', 'p-3 min-h-24 text-sm text-gray-700', 'placeholder:text-sm placeholder:text-gray-400', 'focus:outline focus:outline-2 focus:outline-indigo-400 focus:outline-offset-2', {
                    'border-red-500 text-red-500 placeholder:text-red-300 focus:outline-red-500': error,
                }) }), _jsx(FormErrorMessage, { error: error })] }));
};
